// Description: Email step of the verify email process
// Updated: 20/08/2025
// Author: Simon Franklin

// React
import React from 'react';

// Material UI Components
import { Alert, AlertTitle, Box, FormLabel, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

const FormGrid = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%', // garante que use toda a largura

}));

// Render The Component
const EmailStep = ({ TypeProvider, email, setEmail }) => {
  return (
    <Grid container spacing={3}>
      <FormGrid item xs={12}>
        {(TypeProvider === 'Facebook' || TypeProvider === 'Google') && (
          <Alert severity="info">
            <AlertTitle sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
              E-mail não encontrado
            </AlertTitle>
            <Box sx={{ fontSize: '0.8rem' }}>
              Alguns provedores de identidade, como <strong>Google</strong> e <strong>Facebook</strong>, podem não fornecer o e-mail do usuário no primeiro login.
              Por isso, pedimos que informe um e-mail alternativo para que possamos enviar nosso código de verificação. <br /><br />
              Essa etapa é necessária para garantir a segurança da sua conta. Mas não se preocupe: em seguida, você poderá fazer login normalmente com seu provedor de identidade.
            </Box>
          </Alert>
        )}
      </FormGrid>
      <FormGrid item xs={12}>
        <FormLabel htmlFor="email" sx={{ textAlign: 'left' }}>Email</FormLabel>
        <TextField
          id="email"
          type="email"
          name="email"
          placeholder="seu@email.com"
          autoComplete="email"
          autoFocus
          required
          fullWidth
          variant="outlined"
          value={email}
          sx={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}
          onChange={(e) => setEmail(e.target.value)}
        />
      </FormGrid>
    </Grid>
  );
};

export default EmailStep;
